import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API, setToken, formatApiError } from "@/lib/api";

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google-session`, { session_id: sessionId });
        setToken(data.token);
        window.history.replaceState(null, "", window.location.pathname);
        const dest = data.user.role === "admin" ? "/admin/dashboard" : "/onboarding/portal";
        navigate(dest, { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error(formatApiError(e));
        navigate("/admin", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-blush-50">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-blush-300 border-t-gold" />
        <p className="mt-4 text-sm text-charcoal-muted">Signing you in securely...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
